import { useMemo } from "react";
import { createInternalLink } from "~utils/link_utils/createInternalLink/createInternalLink";

export default function useQueriedArticles(nodes) {
  const articles = useMemo(() => {
    return nodes?.map((node) => {
      const { title, subtitle, date, cover } = JSON.parse(node.content) || {};

      // mock link format expected
      const { full_slug: linkSlug } = node;

      const link = createInternalLink(linkSlug);

      return {
        link,
        title,
        subtitle,
        date,
        cover,
      };
    });
  }, [nodes]);

  const articleAssets = useMemo(() => {
    return nodes?.map((node) => {
      const { cover } = JSON.parse(node.content) || {};

      // Add assets to assets context
      const { assets: nodeAssets } = node;
      const { id: coverId } = cover;

      // Match using string in the format returned
      // by the gatsby-storyblok-asset plugin
      return nodeAssets.find((nodeAsset) => {
        return `File_${coverId}` === nodeAsset.id;
      });
    });
  }, [nodes]);

  return [articleAssets, articles];
}
